import { useState } from "react";
import PersonalSection from "./sections/PersonalSection";
import SummarySection from "./sections/SummarySection";
import ExperienceSection from "./sections/ExperienceSection";
import EducationSection from "./sections/EducationSection";
import SkillsSection from "./sections/SkillsSection";
import ProjectsSection from "./sections/ProjectsSection";
import CertificationsSection from "./sections/CertificationsSection";
import LanguagesSection from "./sections/LanguagesSection";

export default function ResumeForm({ resume, setResume }) {
  const [openSections, setOpenSections] = useState({
    personal: true,
    summary: true,
    experience: true,
    education: false,
    skills: false,
    projects: false,
    certifications: false,
    languages: false,
  });
  const toggle = (id) => setOpenSections((o) => ({ ...o, [id]: !o[id] }));

  const commonProps = { resume, setResume };
  return (
    <div className="space-y-0" data-testid="resume-form">
      <PersonalSection {...commonProps} open={openSections.personal} onToggle={() => toggle("personal")} />
      <SummarySection {...commonProps} open={openSections.summary} onToggle={() => toggle("summary")} />
      <ExperienceSection {...commonProps} open={openSections.experience} onToggle={() => toggle("experience")} />
      <EducationSection {...commonProps} open={openSections.education} onToggle={() => toggle("education")} />
      <SkillsSection {...commonProps} open={openSections.skills} onToggle={() => toggle("skills")} />
      <ProjectsSection {...commonProps} open={openSections.projects} onToggle={() => toggle("projects")} />
      <CertificationsSection {...commonProps} open={openSections.certifications} onToggle={() => toggle("certifications")} />
      <LanguagesSection {...commonProps} open={openSections.languages} onToggle={() => toggle("languages")} />
    </div>
  );
}
